import React, { Suspense, useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { ProtoSchemPromo } from './protoschempromo';

const ParticlesBg = React.lazy(() => import('particles-bg'));

export const Header = (props) => {
  const { t } = useTranslation();
  const [particleNum, setParticleNum] = useState(100);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setParticleNum(20);
    }
  }, []);

  // GA4: track hero DOWNLOAD clicks. Guarded so it never throws if gtag is blocked.
  const handleDownloadClick = () => {
    if (window.gtag) {
      window.gtag('event', 'select_content', {
        content_type: 'app_download',
        item_id: 'com.proto.circuitsimulator',
      });
    }
  };

  return (
    <header id='header'>
      <div className='intro' style={{
      backgroundColor: '#1c2a35'
    }}>
        <Suspense fallback={null}>
          <ParticlesBg type="cobweb" num={particleNum} color="#ffd451" bg={{zIndex: 0, position:"absolute", top:0}} />
        </Suspense>
        <div className='overlay'>
          <div className='container'>

            <div className='row'>
              <div className='col-md-8 col-md-offset-2 intro-text'>
                <h1>
                {t('Header.title')}
                </h1>
                <p>{t('Header.subtitle')}</p>
                <a
                  href='https://play.google.com/store/apps/details?id=com.proto.circuitsimulator&referrer=utm_source%3Dproto_website%26utm_medium%3Dbutton'
                  className='btn btn-custom page-scroll'
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleDownloadClick}
                  aria-label="Download PROTO circuit simulator from Google Play">
                  {t('Header.download')}
                  <img className='btn-custom-logo' src="/img/gp_logo.svg" alt="Google Play"/>

                </a>{' '}
                <ProtoSchemPromo />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
